var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.active_region
    ? _c("div", { staticClass: "contacts-group__city header-city" }, [
        _c("i", { staticClass: "fa fa-location-dot header-city__icon" }),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "header-city__city-btn",
            on: {
              click: function ($event) {
                return _vm.getModalRegions()
              },
            },
          },
          [_vm._v(_vm._s(_vm.active_region.title))]
        ),
        _vm._v(" "),
        _vm.regionsModalVisible
          ? _c(
              "div",
              { staticClass: "header-city__modal-select modal-regions" },
              [
                _c(
                  "button",
                  {
                    staticClass: "close modal-header__close-btn",
                    attrs: { type: "button", "aria-label": "Close" },
                    on: { click: _vm.closeRegionsModal },
                  },
                  [
                    _c("span", { attrs: { "aria-hidden": "true" } }, [
                      _vm._v("×"),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "container" }, [
                  _c("div", { staticClass: "modal-regions__title" }, [
                    _vm._v("Выбрать регион"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "modal-regions__search-city search-city" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.query,
                            expression: "query",
                          },
                        ],
                        staticClass: "form-control modal-regions__search-input",
                        attrs: { type: "text" },
                        domProps: { value: _vm.query },
                        on: {
                          input: [
                            function ($event) {
                              if ($event.target.composing) return
                              _vm.query = $event.target.value
                            },
                            function ($event) {
                              $event.target.composing = false
                            },
                          ],
                        },
                      }),
                      _vm._v(" "),
                      _vm.search_results
                        ? _c(
                            "ul",
                            {
                              staticClass:
                                "search-city__results search-city-results",
                            },
                            _vm._l(_vm.search_results, function (item) {
                              return _c(
                                "li",
                                {
                                  key: "region-search_" + item.id,
                                  staticClass: "search-city-results__item",
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "search-city-results__link",
                                      attrs: { href: "javascript:;" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.setRegion(
                                            item.get_absolute_url
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(item.title))]
                                  ),
                                ]
                              )
                            }),
                            0
                          )
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-regions__content" }, [
                    _c("div", { staticClass: "modal-regions__promotes" }, [
                      _vm.promote_cities
                        ? _c(
                            "ul",
                            {
                              staticClass:
                                "modal-regions__promote-cities promote-cities",
                            },
                            _vm._l(_vm.promote_cities, function (item) {
                              return _c(
                                "li",
                                {
                                  key: "promote_" + item.id,
                                  staticClass: "promote-cities__item",
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "promote-cities__link",
                                      attrs: { href: "javascript:;" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.setRegion(
                                            item.get_absolute_url
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(item.title))]
                                  ),
                                ]
                              )
                            }),
                            0
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "modal-regions__full-list" }, [
                      _c("div", { staticClass: "city-list__label" }, [
                        _vm._v("Все города:"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "modal-regions__list city-list" },
                        [
                          _vm.regions
                            ? _c(
                                "ul",
                                { staticClass: "modal-regions__cities cities" },
                                _vm._l(_vm.regions, function (item) {
                                  return _c(
                                    "li",
                                    {
                                      key: "city_" + item.id,
                                      staticClass: "cities__item",
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "cities__link",
                                          attrs: { href: "javascript:;" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.setRegion(
                                                item.get_absolute_url
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(item.title))]
                                      ),
                                    ]
                                  )
                                }),
                                0
                              )
                            : _vm._e(),
                        ]
                      ),
                    ]),
                  ]),
                ]),
              ]
            )
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }